import React from 'react';
import { Icon, Paper, ClickAwayListener } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
	root: {
		'& .MuiList-root': {
			padding: '0 !important',
		},
		'& .MuiListItem-root:hover': {
			backgroundColor: '#070C13',
		},
		boxShadow: '0px 0px 15px #00000029'
	},
}));

function ReportDropDown(props) {
	const classes = useStyles();
	const [open, setOpen] = React.useState(false);
	const anchorRef = React.useRef(null);
	const { data, selected, onChange, placeholder = 'All Spaces' } = props;

	const handleToggle = () => {
		setOpen((prevOpen) => !prevOpen);
	};

	const handleClose = (event) => {
		if (anchorRef.current && anchorRef.current.contains(event.target)) {
			return;
		}

		setOpen(false);
	};

	function handleListKeyDown(event) {
		if (event.key === 'Tab') {
			event.preventDefault();
			setOpen(false);
		}
	};

	const handleChange = (index, event) => {
		if (onChange) {
			onChange(index);
		}
		handleClose(event);
	};

	if (!data) {
		return <></>;
	}

	return (
		<div className="location-component report">
			<div
				ref={anchorRef}
				className={`flex flex-column selected location-item ${open ? 'active' : ''}`}
				onClick={handleToggle}
			>
				<Icon className="arrow">arrow_drop_down</Icon>
				<div className="flex flex-middle">
					{!selected
						?
						<div className="name">{data.length > 0 ? placeholder : 'No Reports'}</div>
						:
						<div>
							<div className="name">{selected.name}</div>
							<div className="label">{selected.label}</div>
						</div>
					}
				</div>
			</div>
			<div className="location-dropdown" style={{ display: open ? 'block' : 'none' }}>
				<Paper classes={{ root: classes.root }}>
					<ClickAwayListener onClickAway={handleClose}>
						<div onKeyDown={handleListKeyDown}>
							{data.map((item, index) => (
								<div onClick={(event) => handleChange(index, event)} key={index}>
									<div className={`flex flex-column location-item ${selected && selected.id === item.id ? 'selected-drop' : null}`}>
										<div className="name">{item.name}</div>
										<div className="label">{item.label}</div>
									</div>
								</div>
							))}
						</div>
					</ClickAwayListener>
				</Paper>
			</div>
		</div>
	);
}

export default ReportDropDown;
